import React, { useState } from 'react';
import styles from './index.module.css';
import { Dialog, DialogSurface, DialogBody, Button } from '@fluentui/react-components';
import { ArrowExport20Regular } from '@fluentui/react-icons';
import { useDispatch } from 'react-redux';
import { MoveNote } from '../../redux/dashboardSlice';
import { toast } from 'react-toastify';

const MoveEntryModal = ({ isOpen, onOpenChange, noteId, sourceSectionId, sections, onMoveSuccess }) => {
    const dispatch = useDispatch();
    const [selectedSectionId, setSelectedSectionId] = useState(null);
    const [isMoving, setIsMoving] = useState(false);

    // Filter out the current section
    const availableSections = sections?.filter(section => section.id !== sourceSectionId) || [];

    const handleMove = async () => {
        if (!selectedSectionId || !noteId || !sourceSectionId) {
            toast.warning('Please select a section');
            return;
        }

        if (selectedSectionId === sourceSectionId) {
            toast.warning('Note is already in this section');
            return;
        }

        setIsMoving(true);
        try {
            await dispatch(
                MoveNote({
                    noteId: noteId,
                    sourceNotepadId: sourceSectionId,
                    targetNotepadId: selectedSectionId,
                }),
            ).unwrap();

            toast.success('Note moved successfully');
            if (onMoveSuccess) {
                onMoveSuccess(selectedSectionId);
            }
            onOpenChange({ open: false });
            setSelectedSectionId(null);
        } catch (error) {
            console.error('Failed to move note:', error);
            toast.error('Failed to move note');
        } finally {
            setIsMoving(false);
        }
    };

    const handleCancel = () => {
        setSelectedSectionId(null);
        onOpenChange({ open: false });
    };

    return (
        <Dialog open={isOpen} onOpenChange={onOpenChange}>
            <DialogSurface className={styles.shareModal}>
                <DialogBody className={styles.shareModalBody}>
                    <div>
                        <div className="d-flex align-items-center gap-2 mb-3">
                            <ArrowExport20Regular color="var(--Brand-Secondary)" />
                            <p className={styles.sectionShareModalTitle + ' mb-0'}>Move Journal Entry to...</p>
                        </div>
                        <div className="mb-4">
                            {availableSections.length === 0 ? (
                                <p className={styles.shareTeamMemberName}>No other sections available</p>
                            ) : (
                                availableSections.map(section => {
                                    const isSelected = selectedSectionId === section.id;
                                    const tag = section.is_project_default ? 'Public' : section.shared_with?.length > 0 ? 'Shared' : 'Private';
                                    const tagColor = section.is_project_default ? '#DA0C81' : section.shared_with?.length > 0 ? '#192BC2' : '#666';

                                    return (
                                        <div
                                            key={section.id}
                                            className="d-flex align-items-center gap-3 "
                                            style={{
                                                padding: '12px',
                                                backgroundColor: isSelected ? 'rgba(142, 45, 226, 0.05)' : 'transparent',
                                                cursor: 'pointer',
                                                borderTop: '1px solid var(--Neutral-Gray-5, #C6C8D2)',
                                            }}
                                            onClick={() => setSelectedSectionId(section.id)}>
                                            <p className={styles.moveModalText} style={{ margin: 0 }}>
                                                {section.name}
                                            </p>
                                            {tag && tag !== 'Private' && (
                                                <span
                                                    className={styles.sectionTag}
                                                    style={{
                                                        backgroundColor: tagColor,
                                                    }}>
                                                    {tag}
                                                </span>
                                            )}
                                        </div>
                                    );
                                })
                            )}
                        </div>
                        <div className="d-flex gap-2 justify-content-between align-items-center">
                            <button className={styles.modalButtonSave} onClick={handleMove} disabled={!selectedSectionId || isMoving}>
                                {isMoving ? 'Moving...' : 'Move'}
                            </button>
                            <span className={styles.linkBtn} onClick={handleCancel}>
                                Cancel
                            </span>
                        </div>
                    </div>
                </DialogBody>
            </DialogSurface>
        </Dialog>
    );
};

export default MoveEntryModal;
